import React from "react";

import {Breadcrumbs, CssBaseline, Link, Stack, ThemeProvider, Typography} from "@mui/material";
import {lightTheme} from "./Themes";
import {Portada} from "./components/Portada";
import {TopBar} from "./components/TopBar";
import {NavigationMenu} from "./components/NavigationMenu";
import {BottomBanner} from "./components/BottomBanner";
import {Skyline} from "./components/Skyline";
import {Novedades} from "./components/Novedades";

function BreadcrumbSection() {
    return (
        <Breadcrumbs aria-label="breadcrumb" margin={2}>
            <Link underline="hover" color="inherit" href="/">
                Home
            </Link>
            <Typography sx={{ color: 'text.primary' }}>Novedades</Typography>
        </Breadcrumbs>
    );
}

function NovedadesPage() {
    return (
        <ThemeProvider theme={lightTheme}>
            <div className="App">
                <CssBaseline/>
                <Stack alignItems='center'>
                    <TopBar/>
                    <NavigationMenu/>
                    <Portada with_buttons={false} construction_text={false}/>
                    <BreadcrumbSection/>
                    <Novedades/>
                    <Skyline/>
                    <BottomBanner/>
                </Stack>
            </div>
        </ThemeProvider>
    )
}

export default NovedadesPage;